export const NUMBER_ELEMENTS_PER_PAGE = 50;
export const PAGE_COUNTER = 5;

// Limit used to fetch 'all' the elements on paginated endpoints until
// an alternative source of information is available
export const FAKE_NUMBER_ELEMENTS_PER_PAGE = 9999;
export const DATE_FORMAT = "dd/MM/yyyy";
export const DATE_FORMAT_WITH_TIME = "dd/MM/yyyy HH:mm";

export const SUBMISSION_ON_TIME = 'Ontime';
export const SUBMISSION_LATE = 'Late';
export const SUBMISSION_MISSED = 'Missed';

export const WEEK_AUTO_REDEEMED = 2;
export const WEEK_ALERT_AUTO_REDEEMED = 1;

export const PLAN_MONTH_DURATION = {
  one_year_credit: 12,
  six_months_credit: 6,
  three_months_credit: 3,
  one_month_credit: 1
};

export const DISCOUNT_CODE = {
  LITE: 'b2bsmall',
  MEDIUM: 'b2bmedium'
};
export const CODE_SITE = {
  LITE: 'b2b-small/paywall',
  MEDIUM: 'b2b-medium/paywall'
};

export const INTERVAL = {
  ONE_YEAR: { key: 'one_year', value: 12 },
  SIX_MONTHS: { key: 'six_months', value: 6 },
  THREE_MONTHS: { key: 'three_months', value: 3 },
  LIFE_TIME: { key: 'lifetime', value: 30000 }
};

export const ELSA_SPEAK = "elsa_speak";
export const SPEECH_ANALYZER = "speech_analyzer";

export const DEFAULT_PRODUCT_TYPE = 'elsa_speak';

export const SUBSCRIPTION_PRODUCT_TYPES = [ "elsa_speak", "premium" ];

export const PRODUCT_TYPE_OPTIONS = [
  {
    label: 'ELSA Pro',
    value: 'elsa_speak',
  },
  {
    label: 'ELSA Premium',
    value: 'premium',
  },
  {
    label: 'Speech Analyzer',
    value: 'speech_analyzer',
  },
  {
    label: 'OXFORD STARTER',
    value: 'oxford_starter',
  },
  {
    label: 'OXFORD ELEMENTARY',
    value: 'oxford_elementary',
  },
  {
    label: 'OXFORD PRE INTERMEDIATE',
    value: 'oxford_pre_intermediate',
  },
  {
    label: 'OXFORD INTERMEDIATE',
    value: 'oxford_intermediate',
  },
  {
    label: 'OXFORD UPPER INTERMEDIATE',
    value: 'oxford_upper_intermediate',
  },
  {
    label: 'OXFORD ADVANCED',
    value: 'oxford_advanced',
  },
  // {
  //   label: 'PREMIUM',
  //   value: 'premium',
  // },
  // {
  //   label: 'K12 BOOK 1',
  //   value: 'k12_book_1',
  //   content: "topic",
  //   content_ids: ["tenglishd308"]
  // },
  // {
  //   label: 'K12 BOOK 2',
  //   value: 'k12_book_2',
  //   content: "topic",
  //   content_ids: ["tenglishd309"]
  // },
  // {
  //   label: 'K12 BOOK 3',
  //   value: 'k12_book_3',
  //   content: "topic",
  //   content_ids: ["tenglishd310"]
  // },
  // {
  //   label: 'K12 BOOK 6',
  //   value: 'k12_book_6',
  //   content: "topic",
  //   content_ids: ["tenglishd311"]
  // },
  // {
  //   label: 'K12 BOOK 7',
  //   value: 'k12_book_7',
  //   content: "topic",
  //   content_ids: ["tenglishd312"]
  // },
  // {
  //   label: 'K12 BOOK 10',
  //   value: 'K12_BOOK_10',
  //   content: "topic",
  //   content_ids: ["tenglishd313"]
  // },
  {
    label: 'TOEIC by HarperCollins',
    value: 'harcoltoeic',
  },
  {
    label: 'TOEFL by HarperCollins',
    value: 'harcoltoefl',
  },
  {
    label: 'Get ready for IELTS by HarperCollins',
    value: 'harcolielts1',
  },
  {
    label: 'Speaking for IELTS by HarperCollins',
    value: 'harcolielts2',
  },
  // {
  //   label: 'UPenn Books',
  //   value: 'upenn',
  // },
  // {
  //   label: 'IELTS BAND 6',
  //   value: 'ielts6',
  // },
  // {
  //   label: 'IELTS BAND 7',
  //   value: 'ielts7',
  // },
  // {
  //   label: 'IELTS BAND 9',
  //   value: 'ielts9',
  // },
  {
    label: 'EIKEN',
    value: 'eiken',
  },
  {
    label: 'Pearson PTE Prep (B1)',
    value: 'pearson_pte_prep_b1',
  },
  {
    label: 'Pearson PTE Prep (B2)',
    value: 'pearson_pte_prep_b2',
  },
]

export const ELSA_AI = "elsa_ai";
